import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a1a596dc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a596dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1a596dc')) {
      api.createRecord('a1a596dc', component.options)
    } else {
      api.reload('a1a596dc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a1a596dc&scoped=true&", function () {
      api.rerender('a1a596dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z8z8a6v8x0MO/JS/comp/Accordion.vue"
export default component.exports